export const RefundGraphHeader = [
  { id: 1, title: 'No.', flex: 0.7 },
  { id: 2, title: '구분', flex: 1.2 },
  { id: 3, title: '환급상태', flex: 2.2 },
  { id: 4, title: '시술일자', flex: 1.8 },
  { id: 5, title: '국적', flex: 1.2 },
  { id: 6, title: '고객 성함', flex: 3.5 },
  { id: 12, title: '성별', flex: 0.5 },
  { id: 7, title: '의료금액', flex: 3 },
  { id: 8, title: '환급액', flex: 2 },
  { id: 9, title: '최종 결제 금액', flex: 3 },
  { id: 10, title: '서류', flex: 1 },
  { id: 13, title: '수정 요청/내역', flex: 2.4 },
  // { id: 14, title: '해외\n간편결제', flex: 1.4 },
  { id: 11, title: '취소', flex: 1 },
];

export const RefundGraphFullPaymentHeader = [
  { id: 1, title: 'No.', flex: 0.7 },
  { id: 2, title: '구분', flex: 1.2 },
  { id: 3, title: '환급상태', flex: 2.2 },
  { id: 4, title: '시술일자', flex: 1.8 },
  { id: 5, title: '국적', flex: 1.2 },
  { id: 6, title: '고객 성함', flex: 3.5 },
  { id: 12, title: '성별', flex: 0.5 },
  { id: 8, title: '결제금액', flex: 3 },
  { id: 9, title: '예상 환급액', flex: 2 },
  { id: 10, title: '서류', flex: 1 },
  { id: 13, title: '수정 요청/내역', flex: 2.4 },
  // { id: 14, title: '해외\n간편결제', flex: 1.4 },
  { id: 11, title: '취소', flex: 1 },
];

export const RefundGraphFullPaymentHeaderWithKiosk = [
  { id: 1, title: 'No.', flex: 0.7 },
  { id: 2, title: '구분', flex: 1.2 },
  { id: 3, title: '환급상태', flex: 2.2 },
  { id: 4, title: '시술일자', flex: 1.8 },
  { id: 5, title: '국적', flex: 1.2 },
  { id: 6, title: '고객 성함', flex: 3.5 },
  { id: 12, title: '성별', flex: 0.5 },
  { id: 8, title: '결제금액', flex: 3 },
  { id: 9, title: '예상 환급액', flex: 2 },
  { id: 7, title: '키오스크 환급액', flex: 3 },
  { id: 10, title: '서류', flex: 1 },
  { id: 13, title: '수정 요청/내역', flex: 2.4 },
  // { id: 14, title: '해외\n간편결제', flex: 1.4 },
  { id: 11, title: '취소', flex: 1 },
];

export const RefundDetailHeader = [
  { id: 1, title: '시술일자', flex: 1 },
  { id: 2, title: '국적', flex: 1 },
  { id: 3, title: '고객 성함', flex: 1 },
  { id: 12, title: '성별', flex: 0.5 },
  { id: 4, title: '의료금액', flex: 1 },
  { id: 5, title: '환급액', flex: 1 },
  { id: 6, title: '최종 결제 금액', flex: 1 },
];
export const RefundDetailFullPaymentHeader = [
  { id: 1, title: '시술일자', flex: 1 },
  { id: 2, title: '국적', flex: 1 },
  { id: 3, title: '고객 성함', flex: 1 },
  { id: 12, title: '성별', flex: 0.5 },
  { id: 6, title: '결제금액', flex: 1 },
  { id: 5, title: '예상 환급액', flex: 1 },
];

export const RefundHomeHeader = [
  { id: 1, title: 'No.', flex: 1 },
  { id: 2, title: '구분', flex: 1.5 },
  { id: 3, title: '시술일자', flex: 2.5 },
  { id: 4, title: '국적', flex: 2.5 },
  { id: 5, title: '고객성함', flex: 2.5 },
  { id: 6, title: '의료금액', flex: 2.5 },
  { id: 7, title: '환급액', flex: 2.5 },
  { id: 8, title: '최종 결제 금액', flex: 2.5 },
  { id: 9, title: '서류', flex: 2.5 },
];

export const RefundHomeFullPaymentHeader = [
  { id: 1, title: 'No.', flex: 1 },
  { id: 2, title: '구분', flex: 1.5 },
  { id: 3, title: '시술일자', flex: 2.5 },
  { id: 4, title: '국적', flex: 2.5 },
  { id: 5, title: '고객 성함', flex: 2.5 },
  { id: 12, title: '성별', flex: 0.5 },
  { id: 6, title: '결제금액', flex: 2.5 },
  { id: 7, title: '예상환급액', flex: 2.5 },
  { id: 8, title: '서류', flex: 2.5 },
];

export const NoticeHomeHeader = [
  { id: 1, title: 'No.', flex: 1 },
  { id: 2, title: '제목', flex: 12 },
  { id: 3, title: '게시 일자', flex: 1.5 },
  { id: 4, title: '작성자', flex: 1.5 },
];

export const isNotFiltering = [
  'No.',
  '구분',
  '환급상태',
  '서류',
  '취소',
  '수정 요청/내역',
  '해외\n간편결제',
];
